<template>
  <div class="data-maintenance">
    <a-result
      v-if="!hasPermission"
      status="403"
      title="无权限"
      sub-title="您没有数据维护权限，无法访问此页面"
    >
      <template #extra>
        <a-button type="primary" @click="$router.push('/list')">返回列表</a-button>
      </template>
    </a-result>
    <a-tabs v-else v-model="activeTab" @change="handleTabChange">
      <a-tab-pane key="players" tab="球员管理">
        <div class="toolbar">
          <a-select v-model="playerTypeFilter" style="width: 120px; margin-right: 8px;">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="men">男队</a-select-option>
            <a-select-option value="women">女队</a-select-option>
            <a-select-option value="youth_men">青年男队</a-select-option>
            <a-select-option value="youth_women">青年女队</a-select-option>
            <a-select-option value="foreign_men">外协会男队</a-select-option>
            <a-select-option value="foreign_women">外协会女队</a-select-option>


          </a-select>
          <a-button type="primary" @click="showAddModal('players')">新增球员</a-button>
          <a-button @click="reloadData('players')">重载数据</a-button>
        </div>
        <a-table
          :columns="playerColumns"
          :data-source="filteredPlayers"
          :pagination="playerPagination"
          :loading="loading"
          row-key="player_id"
        >
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button size="small" @click="editRecord('players', record)">编辑</a-button>
              <a-button size="small" type="danger" @click="deleteRecord('players', record)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </a-tab-pane>

      <a-tab-pane key="matches" tab="比赛管理">
        <div class="toolbar">
          <a-button type="primary" @click="showAddModal('matches')">新增比赛</a-button>
          <a-button @click="reloadData('matches')">重载数据</a-button>
        </div>
        <a-table
          :columns="matchColumns"
          :data-source="matches"
          :pagination="matchPagination"
          :loading="loading"
          row-key="match_id"
          @change="handleMatchTableChange"
        >
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button size="small" @click="editRecord('matches', record)">编辑</a-button>
              <a-button size="small" type="danger" @click="deleteRecord('matches', record)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </a-tab-pane>

      <a-tab-pane key="participation" tab="参赛管理">
        <div class="toolbar">
          <a-select v-model="currentPlayer" style="width: 200px; margin-right: 8px;" show-search placeholder="选择球员" @change="loadParticipation">
            <a-select-option v-for="p in allPlayers" :key="p.player_id" :value="p.player_id">
              {{ p.player_name }}
            </a-select-option>
          </a-select>
          <a-button type="primary" @click="showAddModal('participation')">新增参赛记录</a-button>
          <a-button @click="reloadData('participation')">重载数据</a-button>
        </div>
        <a-table
          :columns="participationColumns"
          :data-source="participations"
          :loading="loading"
          :row-key="r => r.match_id + '-' + r.player_id"
        >
          <template slot="single" slot-scope="text">
            <span :style="{ color: text === true || text === 'True' ? '#0072BE' : '#999' }">
              {{ text === true || text === 'True' ? '✓' : '-' }}
            </span>
          </template>
          <template slot="double" slot-scope="text">
            <span :style="{ color: text === true || text === 'True' ? '#9364C2' : '#999' }">
              {{ text === true || text === 'True' ? '✓' : '-' }}
            </span>
          </template>
          <template slot="team" slot-scope="text">
            <span :style="{ color: text === true || text === 'True' ? '#00A5AF' : '#999' }">
              {{ text === true || text === 'True' ? '✓' : '-' }}
            </span>
          </template>
          <template slot="mixed" slot-scope="text">
            <span :style="{ color: text === true || text === 'True' ? '#BF936B' : '#999' }">
              {{ text === true || text === 'True' ? '✓' : '-' }}
            </span>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button size="small" @click="editRecord('participation', record)">编辑</a-button>
              <a-button size="small" type="danger" @click="deleteRecord('participation', record)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </a-tab-pane>

      <a-tab-pane key="position" tab="城市坐标">
        <div class="toolbar">
          <a-button type="primary" @click="showAddModal('position')">新增城市</a-button>
        </div>
        <a-table
          :columns="positionColumns"
          :data-source="positions"
          :loading="loading"
          row-key="city_cn_name"
        >
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button size="small" @click="editRecord('position', record)">编辑</a-button>
              <a-button size="small" type="danger" @click="deleteRecord('position', record)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <!-- 新增/编辑弹窗 -->
    <a-modal
        :title="modalTitle"
        :visible="modalVisible"
        @ok="handleModalOk"
        @cancel="handleModalCancel"
        width="600px"
    >
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item v-for="field in currentFields" :key="field.key" :label="field.label">
          <a-input
              v-decorator="[field.key, { initialValue: field.value }]"
              :disabled="field.disabled"
          />
        </a-form-item>
        <a-form-item v-if="currentTable === 'participation'" label="选择比赛">
          <a-select
              v-decorator="['match_id', { rules: [{ required: true, message: '请选择比赛' }] }]"
              placeholder="选择比赛"
          >
            <a-select-option v-for="m in matches" :key="m.match_id" :value="m.match_id">
              {{ m.match_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="currentTable === 'participation'" label="参赛类型">
          <a-checkbox-group v-decorator="['types', { initialValue: ['single'] }]">
            <a-checkbox value="single">单打</a-checkbox>
            <a-checkbox value="double">双打</a-checkbox>
            <a-checkbox value="team">团体</a-checkbox>
            <a-checkbox value="mixed">混双</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>



</template>

<script>
import { message } from 'ant-design-vue'
import {
  getDataPlayers, addDataPlayer, updateDataPlayer, deleteDataPlayer,
  getDataMatches, addDataMatch, updateDataMatch, deleteDataMatch,
  getDataPositions, addDataPosition, updateDataPosition, deleteDataPosition,
  getDataParticipation, addDataParticipation, updateDataParticipation, deleteDataParticipation,
  getTeamPlayers, reloadData, checkMaintainData
} from '@/api'

export default {
  name: 'DataMaintenance',
  data() {
    return {
      activeTab: 'players',
      loading: false,
      hasPermission: false,
      currentTable: '',
      currentRecord: null,

      // 分页（球员使用前端分页）
      playerPagination: { pageSize: 20 },
      matchPagination: { current: 1, pageSize: 20, total: 0 },

      // 数据
      players: [],
      matches: [],
      positions: [],
      allPlayers: [],
      participations: [],

      // 当前选择
      currentPlayer: undefined,
      playerTypeFilter: '',

      // 弹窗
      modalVisible: false,
      modalTitle: '',
      form: this.$form.createForm(this),

      // 列定义
      playerColumns: [
        { title: 'ID', dataIndex: 'player_id', key: 'player_id' },
        { title: '中文名', dataIndex: 'player_name', key: 'player_name' },
        { title: '英文名', dataIndex: 'player_eng_name', key: 'player_eng_name' },
        { title: 'WTT ID', dataIndex: 'player_wtt_id', key: 'player_wtt_id' },
        { title: '类型', dataIndex: 'type', key: 'type' },
        { title: '是否退役', dataIndex: 'is_retired', key: 'is_retired', customRender: (text) => text === 1 ? '是' : '否' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
      ],
      matchColumns: [
        { title: 'ID', dataIndex: 'match_id', key: 'match_id' },
        { title: '比赛名称', dataIndex: 'match_name', key: 'match_name' },
        { title: '英文名称', dataIndex: 'match_eng_name', key: 'match_eng_name' },
        { title: '地点', dataIndex: 'location', key: 'location' },
        { title: '开始日期', dataIndex: 'start_date', key: 'start_date' },
        { title: '结束日期', dataIndex: 'end_date', key: 'end_date' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
      ],
      participationColumns: [
        { title: '球员名', dataIndex: 'player_name', key: 'player_name' },
        { title: '比赛名称', dataIndex: 'match_name', key: 'match_name' },
        { title: '开始日期', dataIndex: 'start_date', key: 'start_date' },
        { title: '单打', dataIndex: 'single', key: 'single', scopedSlots: { customRender: 'single' } },
        { title: '双打', dataIndex: 'double', key: 'double', scopedSlots: { customRender: 'double' } },
        { title: '团体', dataIndex: 'team', key: 'team', scopedSlots: { customRender: 'team' } },
        { title: '混双', dataIndex: 'mixed', key: 'mixed', scopedSlots: { customRender: 'mixed' } },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
      ],
      positionColumns: [
        { title: '城市', dataIndex: 'city_cn_name', key: 'city_cn_name' },
        { title: '经度', dataIndex: 'longitude', key: 'longitude' },
        { title: '纬度', dataIndex: 'latitude', key: 'latitude' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    currentFields() {
      const fields = []
      if (this.currentTable === 'players') {
        // 编辑时显示 player_id（禁用），新增时不显示（由后端自增）
        if (this.currentRecord) {
          fields.push({ key: 'player_id', label: '球员ID', value: this.currentRecord.player_id, disabled: true })
        }
        fields.push(
          { key: 'player_name', label: '中文名', value: this.currentRecord?.player_name },
          { key: 'player_eng_name', label: '英文名', value: this.currentRecord?.player_eng_name },
          { key: 'player_wtt_id', label: 'WTT ID', value: this.currentRecord?.player_wtt_id },
          { key: 'type', label: '类型', value: this.currentRecord?.type || 'men' },
          { key: 'is_retired', label: '是否退役', value: this.currentRecord?.is_retired || 0 }
        )
      } else if (this.currentTable === 'matches') {
        fields.push(
          { key: 'match_id', label: '比赛ID', value: this.currentRecord?.match_id, disabled: !!this.currentRecord },
          { key: 'match_name', label: '比赛名称', value: this.currentRecord?.match_name },
          { key: 'match_eng_name', label: '英文名称', value: this.currentRecord?.match_eng_name },
          { key: 'location', label: '地点', value: this.currentRecord?.location },
          { key: 'start_date', label: '开始日期', value: this.currentRecord?.start_date },
          { key: 'end_date', label: '结束日期', value: this.currentRecord?.end_date }
        )
      } else if (this.currentTable === 'participation') {
        fields.push(
          { key: 'player_id', label: '球员ID', value: this.currentRecord?.player_id || this.currentPlayer, disabled: true },
          { key: 'match_id', label: '比赛ID', value: this.currentRecord?.match_id, disabled: !!this.currentRecord }
        )
      } else if (this.currentTable === 'position') {
        fields.push(
          { key: 'city_cn_name', label: '城市名称', value: this.currentRecord?.city_cn_name, disabled: !!this.currentRecord },
          { key: 'longitude', label: '经度', value: this.currentRecord?.longitude },
          { key: 'latitude', label: '纬度', value: this.currentRecord?.latitude }
        )
      }
      return fields
    },
    availablePlayers() {
      return this.allPlayers
    },
    filteredPlayers() {
      if (!this.playerTypeFilter) return this.players
      return this.players.filter(p => p.type === this.playerTypeFilter)
    }
  },
  async created() {
    await this.checkPermission()
    if (this.hasPermission) {
      this.loadPlayers()
      await this.loadAllPlayers()
      await this.loadMatches()
    }
  },

  watch: {
    '$store.state.currentTeam': function() {
      if (this.hasPermission && this.activeTab === 'participation') {
        this.loadAllPlayers()
      }
    }
  },

  async mounted() {
    // 数据在 created 中已加载
  },
  methods: {
    async checkPermission() {
      try {
        const response = await checkMaintainData()
        if (response.data.allow_maintain && response.data.allow_maintain === 'yes') {
          this.hasPermission = true
        } else {
          message.error('您没有数据维护权限')
          this.$router.push('/list')
        }
      } catch (e) {
        message.error('权限验证失败')
        this.$router.push('/list')
      }
    },

    async handleTabChange() {
      if (this.activeTab === 'players') this.loadPlayers()
      else if (this.activeTab === 'matches') this.loadMatches()
      else if (this.activeTab === 'participation') {
        await this.loadAllPlayers()
        if (!this.matches.length) await this.loadMatches()
      }
      else if (this.activeTab === 'position') this.loadPositions()
    },

    async loadPlayers() {
      this.loading = true
      try {
        // 一次性获取所有数据用于前端筛选
        const res = await getDataPlayers(1, 290)
        if (res.data.success) {
          this.players = res.data.data.items || []
        }
      } catch (e) {
        message.error('加载失败')
      }
      this.loading = false
    },

    async loadAllPlayers() {
      try {
        const team = this.$store.state.currentTeam || 'women'
        const res = await getTeamPlayers(team)
        if (res.data.success) {
          this.allPlayers = res.data.players || []
          if (this.currentPlayer) {
            this.loadParticipation()
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    async loadMatches() {
      this.loading = true
      try {
        const res = await getDataMatches(this.matchPagination.current, this.matchPagination.pageSize)
        if (res.data.success) {
          this.matches = (res.data.data.items || []).sort((a, b) => {
            const dateA = new Date(a.start_date)
            const dateB = new Date(b.start_date)
            return dateA - dateB
          })
          this.matchPagination.total = res.data.data.total || 0
        }
      } catch (e) {
        message.error('加载失败')
      }
      this.loading = false
    },

    async loadParticipation() {
      if (!this.currentPlayer) {
        this.participations = []
        return
      }
      this.loading = true
      try {
        const res = await getDataParticipation(this.currentPlayer)
        if (res.data.success) {
          // 为每条记录添加球员名称和比赛信息
          const player = this.allPlayers.find(p => p.player_id === this.currentPlayer)
          const items = res.data.data?.items || res.data.data || []
          this.participations = items.map(item => {
            const match = this.matches.find(m => m.match_id === item.match_id)
            return {
              ...item,
              player_name: player?.player_name || '',
              match_name: match?.match_name || '',
              start_date: match?.start_date || '',
              // 确保参赛类型字段转换为布尔值
              single: Boolean(item.single==="True"),
              double: Boolean(item.double==="True"),
              team: Boolean(item.team==="True"),
              mixed: Boolean(item.mixed==="True")
            }
          }).sort((a, b) => {
            const dateA = new Date(a.start_date)
            const dateB = new Date(b.start_date)
            return dateA - dateB
          })
        }
      } catch (e) {
        message.error('加载失败')
      }
      this.loading = false
    },

    async loadPositions() {
      this.loading = true
      try {
        const res = await getDataPositions()
        if (res.data.success) {
          this.positions = res.data.data.items || []
        }
      } catch (e) {
        message.error('加载失败')
      }
      this.loading = false
    },

    handleMatchTableChange(pagination) {
      this.matchPagination = { ...this.matchPagination, ...pagination }
      this.loadMatches()
    },

    handleEventTableChange(pagination) {
      this.eventPagination = { ...this.eventPagination, ...pagination }
      this.loadEvents()
    },

    showAddModal(table) {
      this.currentTable = table
      this.currentRecord = null
      this.modalTitle = '新增'
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },

    editRecord(table, record) {
      this.currentTable = table
      this.currentRecord = record
      this.modalTitle = '编辑'
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(record)
      })
    },

    handleModalOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return

        try {
          if (this.currentTable === 'players') {
            if (this.currentRecord) {
              await updateDataPlayer(this.currentRecord.player_id, { data: values })
            } else {
              await addDataPlayer({ data: values })
            }
            this.loadPlayers()
          } else if (this.currentTable === 'matches') {
            if (this.currentRecord) {
              await updateDataMatch(this.currentRecord.match_id, { data: values })
            } else {
              await addDataMatch({ data: values })
            }
            this.loadMatches()
          } else if (this.currentTable === 'participation') {
            const types = values.types || []
            const participationData = {
              player_id: this.currentPlayer,
              match_id: this.currentRecord ? this.currentRecord.match_id : values.match_id,
              single: types.includes('single'),
              double: types.includes('double'),
              team: types.includes('team'),
              mixed: types.includes('mixed')
            }
            if (this.currentRecord) {
              await updateDataParticipation({ data: participationData })
            } else {
              await addDataParticipation({ data: participationData })
            }
            this.loadParticipation()
          } else if (this.currentTable === 'position') {
            if (this.currentRecord) {
              await updateDataPosition(this.currentRecord.city_cn_name, { data: values })
            } else {
              await addDataPosition({ data: values })
            }
            this.loadPositions()
          }
          message.success('操作成功')
          this.modalVisible = false
        } catch (e) {
          message.error('操作失败')
        }
      })
    },

    handleModalCancel() {
      this.modalVisible = false
      this.form.resetFields()
    },

    async deleteRecord(table, record) {
      this.$confirm({
        title: '确定删除?',
        onOk: async () => {
          try {
            if (table === 'players') {
              await deleteDataPlayer(record.player_id)
              this.loadPlayers()
            } else if (table === 'matches') {
              await deleteDataMatch(record.match_id)
              this.loadMatches()
            } else if (table === 'participation') {
              await deleteDataParticipation(record.player_id, record.match_id)
              this.loadParticipation()
            } else if (table === 'position') {
              await deleteDataPosition(record.city_cn_name)
              this.loadPositions()
            }
            message.success('删除成功')
          } catch (e) {
            message.error('删除失败')
          }
        }
      })
    },

    async reloadData(target) {
      try {
        await reloadData(target)
        message.success('重载成功')
      } catch (e) {
        message.error('重载失败')
      }
    },

    filterPlayerOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
      )
    },

    handlePlayerSelect(value) {
      const player = this.allPlayers.find(p => p.player_id === value)
      if (player) {
        this.form.setFieldsValue({ playerType: player.type || 'men' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.data-maintenance {
  padding: 16px;
  background: #fff;
  min-height: 100%;

  .toolbar {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}
</style>
